<template>
  <section class="mx-auto max-w-prose lg:max-w-none">
    <div
      v-if="!loading && !isLoading && press.length === 0"
      class="text-center text-neutral-400"
    >
      There are currently no press releases available.
    </div>
    <div class="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
      <LazyMarketingCardPress
        v-for="(article, index) in press"
        v-if="!loading && !isLoading && press.length > 0"
        :key="index"
        :article="article"
      />
      <LazyMarketingCardPressLoading
        v-for="i in perPage"
        v-if="loading || isLoading"
        :key="i"
      />
      <UCard
        v-if="totalItems > perPage"
        :ui="{
          root: 'bg-neutral-900/40 backdrop-blur-lg col-span-full mx-auto mt-4',
          body: 'p-1 sm:p-1',
        }"
      >
        <UPagination
          v-model:page="currentPage"
          :total="totalItems"
          :items-per-page="perPage"
          :default-page="1"
          :show-edges="true"
          :sibling-count="1"
          @update:page="handlePageChange"
        />
      </UCard>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { PressStoryblok } from '~/types/component-types-sb';
import type { ISbStoryData } from '@storyblok/vue';

const { fetchPress, totalItems, isLoading } = useStoryblokClient();
defineProps({
  blok: {
    type: Object,
    default: () => ({}),
  },
  uuid: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: '',
  },
});

const press = ref<ISbStoryData<PressStoryblok>[]>([]);
const currentPage = ref(1);
const perPage = ref(6);
const loading = ref(true);

// Load press and set them in the reactive `press` array
const loadPress = async (page: number, perPage: number) => {
  loading.value = true;
  try {
    const [stories] = await Promise.all([fetchPress(page, perPage)]);
    press.value = stories as unknown as ISbStoryData<PressStoryblok>[];
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

// Handle page change
const handlePageChange = async (page: number) => {
  await loadPress(page, perPage.value);
  // Optionally scroll to top of the page
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// Initial load
onMounted(async () => {
  await loadPress(currentPage.value, perPage.value);
});
</script>
